module.exports = __webpack_public_path__ + "img/coins.1c99bcce.png";